module.exports = __webpack_public_path__ + "img/alstromeria_lis_des_incas.b1d7f627.jpg";